import Api from "@/services/api";

export default {
  async pesquisaNcmMtrzCancel(dados) {
    const response = await new Api().post("Ncm/pesquisaNcmMatriz", dados, false, 500);
    return response;
  },
  async pesquisaNcmMtrz(dados) {
    const response = await new Api().post("Ncm/pesquisaNcmMatriz", dados);

    return response;
  },
  async pesquisaNcmVigente(dados) {
    const response = await new Api().post("Ncm/pesquisaNcmVigente", dados);

    return response;
  }
};
